module.exports = "/static/Images/en/Six.png";